export default __webpack_public_path__ + "static/media/room1.d1c56105.png";